var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"common-form"},[_c('span',[_vm._v(_vm._s(_vm.curItem.name))])]),_vm._v(" "),_c('el-form',{attrs:{"size":"small","model":_vm.curItem,"label-width":"100px"}}),_vm._v(" "),(_vm.is_linkset)?_c('Setlink',{attrs:{"is_linkset":_vm.is_linkset},on:{"closeDialog":_vm.closeLinkset}},[_vm._v("选择链接")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9f28166","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/page/page/diy/params/Csearch.vue
// module id = null
// module chunks = 